export interface AUTH_USER_INPUT {
  UserName?: string;
  Password?: string;
}

export interface VERIFY_OTP_INPUT {
  OTPCode?: string;
}

export interface RESEND_OTP_INPUT {
}

export interface AUTH_USER_RESPONCE {
  Token?: string;
  IsSzSupport?: boolean;
  VerifyLogInWithOTP?: boolean;
  RegisteredPhasesData?: {
    DoneRegistering?: boolean;
    LastDataVersion?: number;
    LastPhaseNumber?: number;
    RegistrationCycleLogId?: string;
    IsMobileNumberVerified?: boolean;
  };
}

export interface RESEND_INPUT {
  RegistrationCycleLogId?: string;
  VerifyMobileNumberType?: number;
}

export interface FORGET_PASSWORD_INPUT {
  UserName?: string;
  VerifyMobileNumberType?: number;
}

export interface FORGET_PASSWORD_RESPONSE { }

export interface UPDATE_PASSWORD_INPUT {
  UserName: string;
  Code: string;
  newPassword: string;
}

export interface UPDATE_PASSWORD_RESPONSE { }

export interface VERFICATION_RESET_INPUT {
  Code?: string;
  UserName?: string;
}

export interface VERIFY_SIGNUP_INPUT {
  RegistrationCycleLogId?: string;
  VerificationCode?: string;
}

export interface CITY {
  Id?: number;
  GlobalName: string;
}

export interface BUSINESS_TYPE {
  AllowedWithBusinessTypes?: number[];
  BusinessType?: number;
  GlobalName?: string;
  Id?: number;
  ImagePath?: string;
  ImageSelectedPath?: string;
  NotAllowedWithBusinessTypes?: number[];
  active?: boolean;
}

export interface KNOW_US {
  GlobalName: string;
  Id: number;
  ImagePath: string;
}

export interface GET_GENERAL_TOKEN_INPUT {
  BranchId?: number;
  BranchUserId?: number;
  LogInOTPCode?: string;
}

export interface GENERAL_TOKEN_INPUT {
  BranchId?: number;
  BranchUserId?: number;
}
